import baseURL from '../api/url'

export const getStorePostalCodesURL = `${baseURL.CONFIG_URL}/catalogadmin/stores/zip/fetch`
export const getStoreCitiesURL = `${baseURL.CONFIG_URL}/catalogadmin/stores/city/fetch`
export const getStoreEquipmentsURL = `${baseURL.CONFIG_URL}/catalogadmin/stores/equipment/fetch`
export const getStoreMarketplaces = `${baseURL.CONFIG_URL}/catalogadmin/stores/marketplaces/fetch`
export const getStoresListURL = `${baseURL.CONFIG_URL}/catalogadmin/stores/fetch`
export const getStoreByIdURL = `${baseURL.CONFIG_URL}/catalogadmin/stores/details/fetch`
export const getStoreDevicesURL = `${baseURL.CONFIG_URL}/catalogadmin/stores/devices/fetch`
